import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Skeleton from '@mui/material/Skeleton';

const ActivitySkeleton = () => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardMedia
        component="div"
        sx={{
          // 16:9
          pt: '56.25%',
        }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </CardMedia>
      <CardContent sx={{ flexGrow: 1 }}>
        <Skeleton height={20} width="80%" style={{ marginBottom: 6 }} />
        <Skeleton height={16} width="50%" />
      </CardContent>
    </Card>
  );
};

export default ActivitySkeleton;
